/**
 * @generated SignedSource<<69bd59b72b9541cd50f0265d093e2cba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vendorPayoutId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "vendorPayoutId",
    "variableName": "vendorPayoutId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerAccountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoPayout",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedTime",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedBy",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusReason",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeAmountTotal",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payoutAmount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calculationAudit",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTs",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTs",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAppId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qualificationPeriod",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeAmount",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAccountId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSku",
  "storageKey": null
},
v28 = [
  (v25/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountT",
    "kind": "LinkedField",
    "name": "accountTByCustomerAccountId",
    "plural": false,
    "selections": (v4/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AppT",
    "kind": "LinkedField",
    "name": "appTByAppId",
    "plural": false,
    "selections": [
      (v26/*: any*/),
      (v27/*: any*/)
    ],
    "storageKey": null
  }
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeTransactionId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionTime",
  "storageKey": null
},
v32 = [
  (v31/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalChargeTransactionId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vendorPayoutChargeId",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v36 = [
  (v3/*: any*/),
  (v35/*: any*/)
],
v37 = [
  (v25/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountT",
    "kind": "LinkedField",
    "name": "accountTByCustomerAccountId",
    "plural": false,
    "selections": (v36/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AppT",
    "kind": "LinkedField",
    "name": "appTByAppId",
    "plural": false,
    "selections": [
      (v26/*: any*/),
      (v27/*: any*/),
      (v35/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v38 = [
  (v31/*: any*/),
  (v35/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PayoutDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VendorPayoutT",
        "kind": "LinkedField",
        "name": "vendorPayoutTByVendorPayoutId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByResellerAccountId",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserT",
            "kind": "LinkedField",
            "name": "userTByApprovedBy",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramT",
            "kind": "LinkedField",
            "name": "resellerProgramTByResellerPId",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VendorPayoutChargeTsConnection",
            "kind": "LinkedField",
            "name": "vendorPayoutChargeTsByVendorPayoutId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VendorPayoutChargeT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v24/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAppT",
                    "kind": "LinkedField",
                    "name": "customerAppTByCustomerAppId",
                    "plural": false,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalSubscriptionT",
                    "kind": "LinkedField",
                    "name": "externalSubscriptionTByExternalSubscriptionId",
                    "plural": false,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionT",
                    "kind": "LinkedField",
                    "name": "transactionTByChargeTransactionId",
                    "plural": false,
                    "selections": (v32/*: any*/),
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalSubscriptionPaymentT",
                    "kind": "LinkedField",
                    "name": "externalSubscriptionPaymentTByExternalChargeTransactionId",
                    "plural": false,
                    "selections": (v32/*: any*/),
                    "storageKey": null
                  },
                  (v34/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PayoutDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VendorPayoutT",
        "kind": "LinkedField",
        "name": "vendorPayoutTByVendorPayoutId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByResellerAccountId",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserT",
            "kind": "LinkedField",
            "name": "userTByApprovedBy",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v35/*: any*/)
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramT",
            "kind": "LinkedField",
            "name": "resellerProgramTByResellerPId",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v35/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VendorPayoutChargeTsConnection",
            "kind": "LinkedField",
            "name": "vendorPayoutChargeTsByVendorPayoutId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VendorPayoutChargeT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v24/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAppT",
                    "kind": "LinkedField",
                    "name": "customerAppTByCustomerAppId",
                    "plural": false,
                    "selections": (v37/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalSubscriptionT",
                    "kind": "LinkedField",
                    "name": "externalSubscriptionTByExternalSubscriptionId",
                    "plural": false,
                    "selections": (v37/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionT",
                    "kind": "LinkedField",
                    "name": "transactionTByChargeTransactionId",
                    "plural": false,
                    "selections": (v38/*: any*/),
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalSubscriptionPaymentT",
                    "kind": "LinkedField",
                    "name": "externalSubscriptionPaymentTByExternalChargeTransactionId",
                    "plural": false,
                    "selections": (v38/*: any*/),
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v35/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "157b3beeaac086ab1b26b1428709387e",
    "id": null,
    "metadata": {},
    "name": "PayoutDetailQuery",
    "operationKind": "query",
    "text": "query PayoutDetailQuery(\n  $vendorPayoutId: UUID!\n) {\n  vendorPayoutTByVendorPayoutId(vendorPayoutId: $vendorPayoutId) {\n    resellerAccountId\n    accountTByResellerAccountId {\n      accountName\n      nodeId\n    }\n    autoPayout\n    approvedTime\n    approvedBy\n    statusReason\n    status\n    chargeAmountTotal\n    payoutAmount\n    calculationAudit\n    created\n    startTs\n    endTs\n    programType\n    userTByApprovedBy {\n      firstName\n      lastName\n      nodeId\n    }\n    resellerPId\n    resellerProgramTByResellerPId {\n      programType\n      programName\n      description\n      customerAppId\n      qualificationPeriod\n      nodeId\n    }\n    vendorPayoutChargeTsByVendorPayoutId {\n      nodes {\n        status\n        chargeAmount\n        payoutAmount\n        customerAppTByCustomerAppId {\n          customerAccountId\n          accountTByCustomerAccountId {\n            accountName\n            nodeId\n          }\n          appTByAppId {\n            appName\n            appSku\n            nodeId\n          }\n          nodeId\n        }\n        externalSubscriptionTByExternalSubscriptionId {\n          customerAccountId\n          accountTByCustomerAccountId {\n            accountName\n            nodeId\n          }\n          appTByAppId {\n            appName\n            appSku\n            nodeId\n          }\n          nodeId\n        }\n        created\n        updated\n        chargeTransactionId\n        transactionTByChargeTransactionId {\n          transactionTime\n          nodeId\n        }\n        externalChargeTransactionId\n        externalSubscriptionPaymentTByExternalChargeTransactionId {\n          transactionTime\n          nodeId\n        }\n        vendorPayoutChargeId\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "65ad3df800a5f0e70f8de1011a545b08";

module.exports = node;
